import { render, staticRenderFns } from "./EvaluationsList.vue?vue&type=template&id=391a7a71"
import script from "./EvaluationsList.vue?vue&type=script&lang=js"
export * from "./EvaluationsList.vue?vue&type=script&lang=js"
import style0 from "./EvaluationsList.vue?vue&type=style&index=0&id=391a7a71&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports